import {
  African,
  Celebrating_the_Soviet_Peopl,
  Cover_Posters,
  Eternal_Gamal_Abdel_Nasser,
  ForThePrisoner,
  Freedom,
  Glory_to_the_October_Homeland,
  GloryToTheHeroes,
  InternationalWomen,
  InternationalWomensDay1982,
  Intifada,
  Intifada1988,
  Intifada1989,
  Land_Day_Palestine,
  Long_Live_Soviet_Palestinian_Friendship,
  LongLive,
  Martyr,
  MassacreOfSabra,
  Naji,
  Nicaragua_Victoriosa,
  PalestineAsk,
  PalestineForThePalestinians,
  PalestinianChildren,
  PalestinianFriendship1986,
  PalestinianPrisoners,
  PalestinianWomen,
  PeopleDemocratic,
  Revolution,
  RevolutionContinues,
  RevolutionUntilVictory,
  Sabra_Shatila_The_Massacref,
  Sana_Muhaidl_The_Bride_of_the_South,
  Solidaridad_Chily,
  SolidaridadCON,
  Solidarity,
  SongOfFreedom,
  st_Anniversary_of_the_Palestinian_Revolution,
  Students,
  SunRises,
  The_Torch_of_Liberation,
  TheChainsMustBreak,
  TheTorchOfLiberation,
  USA,
  VictoryToUprising,
} from "../assets";

const EDITION_LABEL = "Edition of 100";

const rawPosters = [
  // {
  //   name: "Intifada - 1992",
  //   year: 1992,
  //   priceMin: 200,
  //   priceMax: 300,
  //   sizes: ["A3", "A2"],
  //   description:
  //     "Intifada is a powerful poster created in 1992 by renowned Palestinian artist Ghazi Inaim. The artwork reflects the Palestinian struggle through the image of a young girl holding a slingshot—a symbol of courage, resilience, and the spirit of popular resistance during the First Intifada. This poster is a limited edition of 100 and hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: Intifada,
  // },
  {
    name: "The Eternal Gamal Abdel Nasser",
    year: 1986,
    priceMin: 200,
    priceMax: 300,
    sizes: ["A3", "A2"],
    description:
      "The Eternal Gamal Abdel Nasser is a commemorative poster created in 1986 by renowned Palestinian artist Ghazi Inaim. The artwork honors the legacy of Egyptian leader Gamal Abdel Nasser, reflecting themes of Arab unity, dignity, and the lasting impact of his vision across the region. This poster is a limited edition of 100 and hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
    purchaseLink: "https://buy.stripe.com/8x27sK11T0gpabU4h11gt0T",
    image: Eternal_Gamal_Abdel_Nasser,
  },
  // {
  //   name: "South African Women Fight Apartheid",
  //   year: 1986,
  //   priceMin: 200,
  //   priceMax: 300,
  //   sizes: ["A3", "A2"],
  //   description:
  //     "South African Women Fight Apartheid is a powerful poster created in 1986 by renowned Palestinian artist Ghazi Inaim. The artwork highlights the courage and resilience of South African women in their struggle against apartheid, connecting their fight for justice and equality with global movements for freedom and human rights.\n\nThis poster is a limited edition of 100 and hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: African,
  // },
  // {
  //   name: "Students, Workers, and Farmers Revolution",
  //   year: 1987,
  //   priceMin: 200,
  //   priceMax: 300,
  //   sizes: ["A3", "A2"],
  //   description:
  //     "Students, Workers, and Farmers Revolution is a powerful poster created in 1987 by renowned Palestinian artist Ghazi Inaim. The artwork represents the unity and collective action of students, workers, and farmers, portraying them as symbols of resilience, social struggle, and the pursuit of freedom and justice. This poster is a limited edition of 100 and hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: Students,
  // },
  // {
  //   name: "Long Live Soviet-Palestinian Friendship",
  //   year: 1985,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Long Live Soviet-Palestinian Friendship is a commemorative poster created in 1985 by renowned Palestinian artist Ghazi Inaim. The artwork reflects the historical relationship between the Palestinian and Soviet peoples, highlighting themes of solidarity, friendship, and international support during a significant period of political and social history.\n\nThis poster is a limited edition of 100 and hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: LongLive,
  // },
  // {
  //   name: "For the Prisoner, One Day Closer to Freedom",
  //   year: 1989,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "For the Prisoner, One Day Closer to Freedom is a powerful poster created in 1989 by renowned Palestinian artist Ghazi Inaim. The artwork reflects the struggle and hope of Palestinian prisoners, portraying their enduring resilience and their unwavering belief in freedom despite hardship and confinement. This poster is a limited edition of 100 and hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: ForThePrisoner,
  // },
  // {
  //   name: "Intifada - 1989",
  //   year: 1989,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Intifada is a powerful poster created in 1989 by renowned Palestinian artist Ghazi Inaim. The artwork captures the spirit of the First Intifada, reflecting the determination, resilience, and collective struggle of the Palestinian people through bold imagery and symbolic representation.\n\nThis poster is a limited edition of 100 and hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: Intifada1989,
  // },
  // {
  //   name: "Naji Al-Ali with Handala",
  //   year: 1987,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Naji Al-Ali with Handala is a powerful poster created in 1987 by renowned Palestinian artist Ghazi Inaim. The artwork pays tribute to Palestinian cartoonist Naji Al-Ali and his iconic character Handala, a symbol of Palestinian identity, resilience, and the pursuit of justice. Through the image of the pen and Handala, the poster celebrates the enduring power of art as a voice for truth, memory, and resistance.\n\nThis poster is a limited edition of 100 and hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: Naji,
  // },
  // {
  //   name: "Solidarity and Support for the People of Namibia",
  //   year: 1985,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Solidarity and Support for the People of Namibia is a powerful poster created in 1985 by renowned Palestinian artist Ghazi Inaim. The artwork expresses solidarity with the Namibian people in their struggle for freedom and independence, highlighting themes of resistance, dignity, and the shared pursuit of justice among liberation movements around the world.\n\nThis poster is a limited edition of 100 and hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: Solidarity,
  // },
  // {
  //   name: "The Revolution Continues",
  //   year: 1989,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "The Revolution Continues is a powerful poster created in 1989 by renowned Palestinian artist Ghazi Inaim. The artwork reflects the ongoing spirit of struggle, resilience, and commitment to revolutionary ideals, portraying the continuity of collective efforts toward freedom, justice, and social change.\n\nThis poster is a limited edition of 100 and hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: Revolution,
  // },
  // {
  //   name: "Martyr's Day",
  //   year: 1990,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Martyr's Day is a powerful poster created in 1990 by renowned Palestinian artist Ghazi Inaim. The artwork reflects the meaning of remembrance and sacrifice, using symbolic imagery to honor those who gave their lives and to represent resilience, dignity, and the enduring spirit of the Palestinian people.\n\nThis poster is a limited edition of 100 and hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: Martyr,
  // },
  // {
  //   name: "Palestinian Women's Day",
  //   year: 1984,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Palestinian Women's Day is a powerful poster created in 1984 by renowned Palestinian artist Ghazi Inaim. The artwork celebrates the strength, resilience, and vital role of Palestinian women in society and in the national struggle, highlighting their courage, perseverance, and enduring contribution to their communities.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: PalestinianWomen,
  // },
  // {
  //   name: "Intifada - 1988",
  //   year: 1988,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Intifada is a powerful poster created in 1988 by renowned Palestinian artist Ghazi Inaim. The artwork captures the spirit of the First Intifada, reflecting the determination, resilience, and collective struggle of the Palestinian people through bold imagery and symbolic representation.\n\nThis poster is a limited edition of 100 and hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: Intifada1988,
  // },
  // {
  //   name: "International Women's day consolidating the struggle for Equality",
  //   year: "8-3-1986",
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "International Women’s Day – Consolidating the Struggle for Equality is a powerful poster created in March, 1986 by renowned Palestinian artist Ghazi Inaim. The artwork commemorates International Women’s Day and highlights the universal struggle for equality, justice, and women’s rights. Through his symbolic visual language, Inaim connects the Palestinian experience with broader global movements, honoring the strength, resilience, and determination of women everywhere. This poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: InternationalWomen,
  // },
  // {
  //   name: "Palestine for The Palestinians",
  //   year: 1981,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Palestine for the Palestinians is a powerful poster created in 1981 by renowned Palestinian artist Ghazi Inaim. The artwork reflects the deep connection between the Palestinian people and their homeland, emphasizing identity, belonging, and the enduring call for dignity and self-determination. Through his distinctive visual language, Inaim transforms the poster into a symbol of resilience and cultural memory.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: PalestineForThePalestinians,
  // },
  {
    name: "Nicaragua Victoriosa",
    year: 1987,
    priceMin: 200,
    priceMax: 300,
    sizes: ["A3", "A2"],
    description:
      "Victorious Nicaragua is a powerful poster created in 1987 by renowned Palestinian artist Ghazi Inaim. The artwork expresses solidarity with the Nicaraguan people and their pursuit of freedom, sovereignty, and social justice. Through his bold imagery and symbolic style, Inaim connects international struggles for liberation with themes of resistance, resilience, and the enduring hope for a better future.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
    purchaseLink: "https://buy.stripe.com/4gM6oGdOF1ktgAi28T1gt0V",
    image: Nicaragua_Victoriosa,
  },
  // {
  //   name: "Revolution Until Victory",
  //   year: 1984,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Revolution Until Victory is a powerful poster created in 1984 by renowned Palestinian artist Ghazi Inaim. The artwork reflects the spirit of determination, resistance, and the pursuit of freedom, capturing the enduring hope and commitment of the Palestinian people toward justice and victory. Through his expressive visual style, Inaim presents the poster as a symbol of resilience, unity, and the strength of collective struggle.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: RevolutionUntilVictory,
  // },
  // {
  //   name: "The Chains Must Break",
  //   year: 1988,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "The Chains Must Break is a powerful poster created in 1988 by renowned Palestinian artist Ghazi Inaim. The artwork symbolizes the desire for freedom, liberation, and the breaking of restrictions imposed on the Palestinian people. Through its strong imagery and emotional expression, Inaim captures the spirit of resistance, resilience, and the unwavering hope for justice and dignity.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: TheChainsMustBreak,
  // },
  // {
  //   name: "Palestinian Prisoners and Detainees Solidarity Week",
  //   year: "17-24/4/1986",
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Palestinian Prisoners and Detainees Solidarity Week (17–24 April 1986) is a powerful poster created in 1986 by renowned Palestinian artist Ghazi Inaim. The artwork highlights the struggle and resilience of Palestinian prisoners and detainees, reflecting themes of solidarity, remembrance, and the pursuit of freedom and justice. Through his symbolic visual language, Inaim captures the strength, dignity, and unwavering spirit of those affected by imprisonment.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: PalestinianPrisoners,
  // },
  // {
  //   name: "Palestinian Children's Day",
  //   year: 1989,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "On Palestinian Children's Day – Palestinian Children Between Systematic Arrest and Killing is a powerful poster created in 1989 by renowned Palestinian artist Ghazi Inaim. The artwork sheds light on the suffering and vulnerability of Palestinian children, highlighting the impact of conflict, displacement, and violence on young lives. Through his expressive visual language, Inaim portrays children as symbols of resilience, innocence, and the enduring hope for a future of dignity and justice.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: PalestinianChildren,
  // },
  {
    name: "21st Anniversary of the Palestinian Revolution",
    year: "1965-1986",
    priceMin: 200,
    priceMax: 300,
    sizes: ["A3", "A2"],
    description:
      "21st Anniversary of the Palestinian Revolution (1965–1986) is a powerful poster created in 1986 by renowned Palestinian artist Ghazi Inaim. The artwork commemorates the 21st anniversary of the Palestinian Revolution, reflecting themes of remembrance, resilience, and the ongoing pursuit of national identity and justice. Through his distinctive artistic style, Inaim transforms the poster into a visual expression of collective memory, determination, and the enduring spirit of the Palestinian people.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
    purchaseLink: "https://buy.stripe.com/bJe00i3a18MVgAi8xh1gt0Z",
    image: st_Anniversary_of_the_Palestinian_Revolution,
  },
  // {
  //   name: "International Women's Day, A Song of Freedom and Homeland",
  //   year: "8-3-1988",
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "International Women's Day, A Song of Freedom and Homeland is a powerful poster created in 1988 by renowned Palestinian artist Ghazi Inaim. The artwork celebrates the strength and role of Palestinian women as symbols of resilience, commitment, and hope. Through its expressive imagery, the poster portrays women as an essential part of the journey toward freedom, dignity, and the preservation of national identity.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: SongOfFreedom,
  // },
  // {
  //   name: "Long Live Soviet–Palestinian Friendship",
  //   year: 1986,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Long Live Soviet–Palestinian Friendship is a powerful poster created in 1986 by renowned Palestinian artist Ghazi Inaim. The artwork reflects the theme of international solidarity and the historical relationship between the Palestinian and Soviet peoples during that period. Through his distinctive visual language, Inaim presents themes of unity, cooperation, and shared aspirations for justice and self-determination. This poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: PalestinianFriendship1986,
  // },
  {
    name: "Long Live Soviet–Palestinian Friendship",
    year: 1987,
    priceMin: 200,
    priceMax: 300,
    sizes: ["A3", "A2"],
    description:
      "Long Live Soviet–Palestinian Friendship is a powerful poster created in 1987 by renowned Palestinian artist Ghazi Inaim. The artwork reflects the theme of international solidarity and the historical ties between the Palestinian and Soviet peoples during that era. Through his bold and symbolic artistic style, Inaim highlights ideas of friendship, unity, and support among peoples striving for justice and dignity.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
    purchaseLink: "https://buy.stripe.com/bJeaEW8ulbZ73Nw6p91gt11",
    image: Long_Live_Soviet_Palestinian_Friendship,
  },
  {
    name: "Celebrating the Soviet People on the 70th Anniversary of the Great October Revolution",
    year: 1987,
    priceMin: 200,
    priceMax: 300,
    sizes: ["A3", "A2"],
    description:
      "Celebrating the Soviet People on the 70th Anniversary of the Great October Revolution is a powerful poster created in 1987 by renowned Palestinian artist Ghazi Inaim. The artwork commemorates the 70th anniversary of the October Revolution and reflects the themes of historical remembrance, international solidarity, and the connections between global political movements of the time. Through his distinctive visual language, Inaim captures the spirit of commemoration, unity, and shared aspirations for social justice.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
    purchaseLink: "https://buy.stripe.com/8x2dR84e5aV383MbJt1gt0X",
    image: Celebrating_the_Soviet_Peopl,
  },
  // {
  //   name: "Freedom, Glory, and Victory for African Prisoner Nelson Mandela",
  //   year: 1987,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Freedom, Glory, and Victory for African Prisoner Nelson Mandela is a powerful poster created in 1987 by renowned Palestinian artist Ghazi Inaim. The artwork expresses solidarity with Nelson Mandela and the anti-apartheid struggle in South Africa, highlighting the universal values of freedom, justice, and human dignity. Through his symbolic visual language, Inaim connects the Palestinian experience with global movements for liberation and celebrates the resilience of those who struggle against oppression.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: Freedom,
  // },
  // {
  //   name: "People's Democratic Republic of Yemen",
  //   year: 1986,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "People's Democratic Republic of Yemen is a powerful poster created in 1986 by renowned Palestinian artist Ghazi Inaim. The artwork reflects the themes of solidarity, political identity, and international connections during that period, expressing support for the People's Democratic Republic of Yemen. Through his distinctive visual language, Inaim highlights ideas of progress, unity, and collective aspirations.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: PeopleDemocratic,
  // },
  // {
  //   name: "Solidaridad con El Salvador",
  //   year: 1987,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Solidaridad con El Salvador (Solidarity with El Salvador) is a powerful poster created in 1987 by renowned Palestinian artist Ghazi Inaim. The artwork expresses solidarity with the people of El Salvador and their struggle for peace, justice, and social rights. Through his distinctive visual language, Inaim connects global movements for freedom and dignity, highlighting themes of resistance, unity, and the shared pursuit of a better future.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: SolidaridadCON,
  // },
  {
    name: "Sabra-Shatila - The Massacre",
    year: "17-9-1982",
    priceMin: 200,
    priceMax: 300,
    sizes: ["A3", "A2"],
    description:
      "Sabra–Shatila (The Massacre) – 17 September 1982 is a powerful poster created by renowned Palestinian artist Ghazi Inaim. The artwork commemorates the tragic Sabra and Shatila massacre and reflects the pain, loss, and suffering experienced by Palestinian refugees. Through his emotional and symbolic visual language, Inaim preserves the memory of the victims while expressing themes of remembrance, resilience, and the enduring call for justice.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
    purchaseLink: "https://buy.stripe.com/bJe9ASdOFaV34RAfZJ1gt0Y",
    image: Sabra_Shatila_The_Massacref,
  },
  // {
  //   name: "Palestine Ask European Union",
  //   year: 1982,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Palestine Asks the European Union is a powerful poster created in 1982 by renowned Palestinian artist Ghazi Inaim. The artwork reflects the Palestinian call for international recognition, solidarity, and support, highlighting the importance of global engagement with the Palestinian cause. Through his distinctive visual language, Inaim presents themes of dialogue, justice, and the pursuit of political and humanitarian awareness.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: PalestineAsk,
  // },
  // {
  //   name: "Victory to Uprising",
  //   year: 1982,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Victory to Uprising is a powerful poster created in 1982 by renowned Palestinian artist Ghazi Inaim. The artwork reflects the spirit of resistance, determination, and collective struggle, expressing themes of resilience and the pursuit of freedom. Through his bold and symbolic visual language, Inaim captures the strength of popular movements and the enduring hope for justice and victory.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: VictoryToUprising,
  // },
  {
    name: "Land Day Palestine",
    year: "30-3-1988",
    priceMin: 200,
    priceMax: 300,
    sizes: ["A3", "A2"],
    description:
      "Land Day – Palestine (30 March 1988) is a powerful poster created in 1988 by renowned Palestinian artist Ghazi Inaim. The artwork commemorates Palestinian Land Day, a day of remembrance and affirmation of the deep connection between the Palestinian people and their land. Through his distinctive visual language, Inaim highlights themes of identity, belonging, resilience, and the enduring defense of cultural and national heritage.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
    purchaseLink: "https://buy.stripe.com/3cIcN4aCt5AJgAi5l51gt0U",
    image: Land_Day_Palestine,
  },
  {
    name: "Solidaridad Chily",
    year: 1981,
    priceMin: 200,
    priceMax: 300,
    sizes: ["A3", "A2"],
    description:
      "Solidaridad Chile (Solidarity with Chile) is a powerful poster created in 1981 by renowned Palestinian artist Ghazi Inaim. The artwork expresses solidarity with the people of Chile and reflects themes of freedom, justice, and resistance against oppression. Through his distinctive visual language, Inaim connects international struggles for human rights and dignity, emphasizing the shared aspirations of peoples seeking peace and liberation.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
    purchaseLink: "https://buy.stripe.com/28E00i5i94wFesa14P1gt0W",
    image: Solidaridad_Chily,
  },
  // {
  //   name: "USA – Dove of Peace",
  //   year: 1990,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "USA – Dove of Peace is a powerful poster created in 1990 by renowned Palestinian artist Ghazi Inaim. The artwork explores the symbolism of peace and international relations, using the image of the dove as a universal symbol of hope, harmony, and the aspiration for a more just world. Through his distinctive artistic language, Inaim invites reflection on the contrast between ideals of peace and the realities of global political struggles.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: USA,
  // },
  // {
  //   name: "The Sun Rises from the South",
  //   year: 1985,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "The Sun Rises from the South is a powerful poster created in 1985 by renowned Palestinian artist Ghazi Inaim. The artwork reflects themes of resilience, hope, and renewal, using the symbolism of the rising sun to represent strength and the promise of a new beginning. Through his expressive visual language, Inaim captures the spirit of the Lebanese people and their enduring connection to freedom, dignity, and perseverance.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: SunRises,
  // },
  {
    name: "Sana'a Muhaidli – The Bride of the South",
    year: 1985,
    priceMin: 200,
    priceMax: 300,
    sizes: ["A3", "A2"],
    description:
      "Sana'a Muhaidli – The Bride of the South is a powerful poster created in 1985 by renowned Palestinian artist Ghazi Inaim. The artwork commemorates the life, martyrdom, and active role of Sana'a Muhaidli, who became a symbol of sacrifice and resistance in Lebanon. Through his expressive visual language, Inaim honors her memory and highlights the themes of courage, commitment, and the role of individuals in moments of historical struggle.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
    purchaseLink: "https://buy.stripe.com/bJe6oGcKBe7fck28xh1gt10",
    image: Sana_Muhaidl_The_Bride_of_the_South,
  },
  // {
  //   name: "Glory to the Heroes of Castle",
  //   year: 1984,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "Glory to the Heroes of Castle – Symbol of Steadfastness and Defiance is a powerful poster created in 1984 by renowned Palestinian artist Ghazi Inaim. The artwork honors the fighters who defended Beaufort Castle (Qal'at al-Shaqif), portraying it as a symbol of resilience, courage, and resistance.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: GloryToTheHeroes,
  // },
  // {
  //   name: "The Revolution Continues from Generation to Generation",
  //   year: 1987,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "The Revolution Continues from Generation to Generation is a powerful poster created in 1987 by renowned Palestinian artist Ghazi Inaim. The artwork reflects the continuity of collective memory, struggle, and aspirations across generations.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: RevolutionContinues,
  // },
  // {
  //   name: "The Massacre of Sabra–Shatila",
  //   year: "17-9-1982",
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: [],
  //   description:
  //     "The Massacre of Sabra–Shatila – 17 September 1982 is a powerful poster created by renowned Palestinian artist Ghazi Inaim. The artwork commemorates the victims of the Sabra and Shatila massacre and reflects the tragedy, suffering, and collective memory surrounding this event. Through the use of stark symbolism and emotional imagery, Inaim confronts the impact of violence and preserves the memory of those who lost their lives, while expressing themes of remembrance, justice, and human dignity.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: MassacreOfSabra,
  // },
  // {
  //   name: "International Women's Day - 1982",
  //   year: 1982,
  //   priceMin: 200,
  //   priceMax: 200,
  //   sizes: ["A3", "A2"],
  //   description:
  //     "International Women's Day – Solidarity Day with Palestinian Women is a powerful poster created in 1982 by renowned Palestinian artist Ghazi Inaim. The artwork commemorates International Women's Day and expresses solidarity with Palestinian women, highlighting their resilience, strength, and essential role in society and the national struggle. Through his symbolic visual language, Inaim celebrates women as figures of courage, perseverance, and hope.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist. Each edition preserves the historical and artistic value of the original work. Today, this iconic poster is preserved on the blockchain by Funooni, ensuring its authenticity, provenance, and lasting legacy for future generations.",
  //   purchaseLink: "",
  //   image: InternationalWomensDay1982,
  // },
  {
    name: "Glory to the October Homeland!",
    year: 1987,
    priceMin: 200,
    priceMax: 300,
    sizes: ["A3", "A2"],
    description:
      "Glory to the October Homeland! is a striking poster that celebrates the legacy of the October Revolution in 1987 and the ideals of unity that shaped the Soviet era. The artwork features the iconic hammer and sickle symbol, constructed from the flags of the various Soviet Socialist Republics, set against a powerful red background illuminated by a radiant star. Through this bold composition, the poster reflects themes of collective identity, solidarity, and the unity of the Soviet republics.\n\nThis poster is a limited edition, hand-signed and numbered by the artist, preserving the historical and artistic significance of the original work. Today, this iconic piece is immortalized on the blockchain by Funooni, ensuring its authenticity, secure provenance, and lasting legacy for future generations.",
    purchaseLink: "https://buy.stripe.com/6oU9AS3a10gpfwe3cX1gt0R",
    image: Glory_to_the_October_Homeland,
  },
  {
    name: "The Torch of Liberation (1984)",
    year: 1984,
    priceMin: 200,
    priceMax: 300,
    sizes: ["A3", "A2"],
    description:
      "The Torch of Liberation (1984) is a striking poster created by renowned Palestinian artist Ghazi Inaim, reflecting the revolutionary spirit and political symbolism of its era. The artwork features a rifle transformed into a torch, with its flame framed by the colors of the Palestinian flag. Set against bold horizontal bands of vibrant colors, the composition creates a powerful visual contrast between struggle, sacrifice, and hope. Through this symbolic transformation, the poster presents resistance as a source of light and liberation.\n\nThis poster is a limited edition of 100, hand-signed and numbered by the artist, preserving the historical and artistic significance of the original work. Today, this iconic piece is immortalized on the blockchain by Funooni, ensuring its authenticity, secure provenance, and lasting legacy for future generations.",
    purchaseLink: "https://buy.stripe.com/9B6cN49ypaV3abUeVF1gt0S",
    image: The_Torch_of_Liberation,
  },
];

export const postersProducts = rawPosters.map((poster, index) => ({
  id: `poster-${String(index + 1).padStart(2, "0")}`,
  edition: EDITION_LABEL,
  currency: "USD",
  ...poster,
}));

export const postersCollection = {
  title: "Posters Collection",
  subtitle: "The Art of Resistance",
  tags: [`${postersProducts.length} items`, "Physical Purchase"],
  description:
    "Poster art is a powerful form of visual expression connecting art, history, politics, and cultural identity. For decades, artists have used posters to communicate ideas, document important moments, and express themes of resistance, freedom, solidarity, and social justice. Through bold imagery and symbolism, poster art reflects the stories, struggles, and identities of societies across generations.",
  ctaLabel: "View Collection",
  coverImages: [Cover_Posters],
  article: {
    sectionLabel: "Poster Collection Story",
    title: "Posters as Visual Records of History",
    sections: [
      {
        subtitle: "Posters as Memory",
        paragraphs: [
          "Throughout modern history, posters have played a unique role in documenting ideas, movements, and cultural moments. Beyond their visual appeal, they serve as historical records that reflect the perspectives, emotions, and events of their time. Combining illustration, typography, symbolism, and artistic vision, posters have captured the voices of societies, communicated powerful messages, and preserved memories that might otherwise fade.",
          "The Posters Collection (1965–1990) brings together significant works from this influential period, highlighting the connection between art and history. Featuring iconic creations by Ghazi Inaim, one of the pioneers of Palestinian poster art and other artists, the collection reflects how posters can represent identity, social awareness, solidarity, and human experiences through powerful visual storytelling. These artworks stand as cultural documents that preserve the ideas, emotions, and historical context behind each creation.",
        ],
      },
      {
        subtitle: "Preserving Cultural Stories Through Art",
        paragraphs: [
          "Funooni preserves these historic artworks by carefully digitizing, restoring, and transforming them into authenticated limited-edition collectibles while maintaining their original artistic character and historical significance. Each poster is released as a limited edition of 100 prints in A3 size, offering collectors the opportunity to own a carefully preserved piece of visual history.",
          "Every edition is accompanied by a Certificate of Authenticity (COA), a unique serial number, a holographic smart QR code, and blockchain verification, creating a trusted connection between the collector and the original artwork while ensuring transparent provenance and long-term preservation.",
        ],
      },
    ],
  },
  products: postersProducts,
};

export default postersCollection;
